<template>
  <bootstrap-modal
    v-if="showModal"
    class="preorder-search-email-modal"
    size="lg"
    title="Access Your Order"
    @modal-close="closeModal"
  >
    <template v-slot:header>
      <div class="preorder-search-email-modal__header">
        <button
          type="button"
          class="close modal__close-button preorder-search-email-modal__close-button"
          aria-label="Close"
          @click="closeModal"
        ><span aria-hidden="true">×</span></button>
      </div>
    </template>
    <template v-slot:body>
      <div class="preorder-search-email-modal__body">
        <div class="row">
          <div class="col-xs-12">
            <h3 class="preorder-search-email-modal__body-title">
              Access Your Order
            </h3>
          </div>
        </div>
        <div class="row preorder-search-email-modal__body-row">
          <div
            v-show="searchComplete === false"
            class="col-xs-12 col-md-8 col-md-offset-2"
          >We have detected existing orders for this customer.  Please enter the email associated with the order to be emailed the link to access the order.</div>
          <div
            v-show="searchComplete"
            class="col-xs-12 col-md-8 col-md-offset-2"
          ><b>Thank you.</b> You will receive an email within 24 hours containing a link to access your images. If you do not receive an email, please contact customer service at <a href="mailto:support@marathonfoto.com">support@marathonfoto.com</a>.
          </div>
        </div>
        <div
          v-show="searchComplete === false"
          class="row"
        >
          <div class="col-xs-6 col-md-4 col-md-offset-2">
            <input
              v-model="email"
              type="text"
              class="form-control preorder__search-input preorder__search-email"
              placeholder="Email Address"
            >
          </div>
          <div class="col-xs-6 col-md-4">
            <button
              :disabled="buttonIsDisabled"
              class="button button--cta button--fw"
              @click="handleSearchClick"
            >
              SEARCH
              <div
                v-show="searchInProgress"
                class="button__image button__image--wait-right"
              />
              <div
                v-show="searchInProgress === false"
                class="button__image button__image--arrow-right"
              />
            </button>
          </div>
        </div>
      </div>
    </template>
  </bootstrap-modal>
</template>

<script>
import BootstrapModal from '@/shared/components/BootstrapModal.vue'

export default {
  name: 'SearchEmailModal',
  components: {
    BootstrapModal
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchInProgress: false,
      email: '',
      searchComplete: false
    }
  },
  computed: {
    siteRoot () {
      return this.$store.state.siteRoot
    },
    buttonIsDisabled () {
      return this.searchInProgress || this.email === ''
    }
  },
  methods: {
    handleSearchClick () {
      this.searchInProgress = true
      this.$http.post(`${this.siteRoot}Proofs/SearchPreOrdersByEmail`, { email: this.email })
        .then(resp => {
          this.searchComplete = true
        }).catch(error => {
          alert(error)
        }).finally(() => {
          this.searchInProgress = false
        })
    },
    closeModal () {
      this.$emit('close-modal')
    }
  }
}
</script>

<style lang="scss" scoped>
  .preorder-search-email-modal {
    padding: 20px;

    * {
      font-family: $opensans;
    }

    &__close-button {
      background-image: url('./assets/modal-close.svg') !important;
      width: 18px;
      height: 18px;
    }

    &__header {
      padding: 10px;
    }

    &__body {
      padding: 1rem;
      text-align: center;

      @media screen and (min-width: $screen-sm-min) {
        padding: 3rem;
      }

      &-row {
        margin-bottom: 2rem;

        &--vertical-align {
          @media screen and (min-width: $screen-sm-min) {
            display: flex;
            align-items: center;
          }
        }
      }

      &-title {
        font-weight: 800;
        margin: 0 0 2rem 0;
        padding: 0;
      }

      & h4 {
        margin-bottom: 10px;

        @media screen and (min-width: $screen-sm-min) {
          font-size: 1.4rem;
          margin-bottom: 20px;
        }

        @media screen and (min-width: $screen-lg-min) {
          font-size: 1.4rem;
        }
      }

      & p {
        @media screen and (min-width: $screen-sm-min) {
          font-size: 1.2rem;
          line-height: 1.8rem;
        }

        @media screen and (min-width: $screen-lg-min) {
          padding: 0 4rem;
        }
      }
    }

    &__cta-link {
      background: #f87b5e;
      border-radius: 12px;
      color: #fff;
      font-size: 1.2rem;
      font-weight: 600;
      height: auto;
      line-height: 2rem;
      margin: 0 auto 2rem auto;
      padding: 10px 20px;
      text-align: center;
      text-transform: none;
      width: 100%;

      @media screen and (min-width: $screen-sm-min) {
        width: auto;
      }
    }

    &__close-link {
      color: #f87b5e;
      font-size: 1.4rem;
      font-weight: 700;
      text-decoration: underline;
    }
  }
</style>



// WEBPACK FOOTER //
// WebResources/vue/proofs/index/components/PreOrderSearchEmail/SearchEmailModal.vue